export default __webpack_public_path__ + "static/media/Empty_Tube.30d60b80.svg";